<template>
    <div>
        <div class="wrapper">
            <!-- 主内容区 -->
            <div class="indicator-con">
                <div class="top-wrapper">
                    <el-input
                        class="search"
                        v-model="keyword"
                        suffix-icon="el-icon-search"
                        placeholder="输入指标名称搜索"
                        size="small"/>
                </div>
                <div class="indicator-wrapper">
                    <div class="indicator-side">
                        <div
                            :class="['indicator-category',category == item.type ? 'indicator-category--active' : '',]"
                            v-for="(item, key, index) in indicatorData"
                            :key="key"
                            @click="changeCategory(item, index)"
                            v-show="categoryShow(item)"
                        >
                            {{ item.display_name }}
                        </div>
                    </div>
                    <!-- 勾选框区域 -->
                    <div class="indicator-body">
                        <div
                            class="indicator-block"
                            v-for="(pitem, key) in indicatorData"
                            :key="key"
                            v-show="categoryShow(pitem)"
                        >
                            <div class="indicator-group mb10">
                                <el-checkbox
                                    class="ml10"
                                    :value="pitem.checked"
                                    :reset-data="resetData"
                                    :indeterminate="pitem.isIndeterminate"
                                    true-label="true"
                                    false-label="false"
                                    @change="handleCheckAllChange(!pitem.checked, pitem.type, pitem)">
                                    {{ pitem.display_name }}
                                </el-checkbox>
                            </div>
                            <div>
                                <div class="dragArea list-group el-row">
                                    <el-row :gutter="0">
                                        <el-col :span="8" v-for="(element, index) in pitem.children" :key="element.id+'_'+index"  v-show="indicatorShow(element)">
                                            <el-checkbox
                                                class="mb10"
                                                :value="element.checked"
                                                :reset-data="resetData"
                                                :label="element"
                                                :disabled="element.disabled ? element.disabled : false"
                                                true-label="true"
                                                false-label="false"
                                                @change="checkItem(!element.checked, element, key)">
                                                <span v-if="element['display_name'] && element['display_name'].length < 10">{{ element['display_name'] }}</span>
                                                <el-tooltip
                                                    v-else
                                                    effect="dark" :content="element['display_name']"
                                                    placement="top"
                                                    :open-delay="200">
                                                    <span>{{ element['display_name'].substring(0 , 9) }}...</span>
                                                </el-tooltip>
                                            </el-checkbox>
                                            <el-tooltip
                                                v-if="element['field_type'] == 2 && element['meconfig']"
                                                effect="dark" :content="toquestiontitle(element['meconfig'])"
                                                placement="top"
                                                :open-delay="200">
                                                <span class="questions">?</span>
                                            </el-tooltip>
                                        </el-col>
                                    </el-row>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 右侧 -->
            <div class="indicator-drag">
                <div class="drag-title">
                    <span>已选 <i>{{ Number(fixedData.length) + Number(dragData.length) }}</i> 个字段</span>
                    <span @click="handleClear">清除全部</span>
                </div>
                <!-- 以下指标将横向固定 -->
                <div class="indicator-drag-srcoll">
                    <p class="pl8 font12px text-bold mt6 mb6">冻结列</p>
                    <Draggable
                        ghost-class="drag-ghost"
                        :class="['indicator-limit-many']"
                        :list="fixedData"
                        :group="{ name: 'dragGroup', put: true }"
                        item-key="value"
                        @change="topGroupChange">
                        <div
                            :class="[
                                    'indicator-drag-block',
                                    'drag-block',
                                    'hover-class',
                                    'all-scroll',
                                    'mg5',
                                    ]"
                            v-for="(element, index) in fixedData"
                            :key="index"
                        >
                            <div class="indicator-drag-block-left">
                                <i class="el-icon-rank" style="margin-right: 4px;"></i>
                                <span class="indicator-name font12px">{{ element.display_name }}</span>
                            </div>
                            <i class="el-icon-close text-color-error" title="删除"  v-if="!element.disabled" @click="changeDrag(element, 2, 'top')"></i>
                        </div>
                    </Draggable>
                    <p class="fixed_line font12px tac pt10 pb10 text-bold">以下列不冻结</p>
                    <!--可拖拽指标-->
                    <Draggable
                        ghost-class="drag-ghost"
                        class="indicator-limit-many"
                        :list="dragData"
                        :group="{ name: 'dragGroup', put: true }"
                        item-key="value"
                        ref="indicatorDragRef"
                        @change="bottomGroupChange">
                        <div
                            :class="[
                                    'indicator-drag-block',
                                    'drag-block',
                                    'hover-class',
                                    'all-scroll',
                                    'mg5',
                                    ]"
                            v-for="(element, index) in dragData"
                            :key="index"
                        >
                            <div class="indicator-drag-block-left">
                                <i class="el-icon-rank" style="margin-right: 4px;"></i>
                                <span class="indicator-name font12px">{{ element.display_name }}</span>
                            </div>

                            <i class="el-icon-close text-color-error" title="删除"  v-if="!element.disabled" @click="changeDrag(element, 2, 'bottom')"></i>
                        </div>
                    </Draggable>
                </div>


                <!-- <div class="indicator-drag-srcoll" style="min-height: 300px;">

                </div> -->
            </div>

        </div>

        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">保存</el-button>
        </p>
    </div>
</template>

<script>
    import Draggable from 'vuedraggable';
    import {uniqBy, cloneDeep, uniq} from 'lodash'
    export default {
        name: "customizeModal",
        components: {
            Draggable
        },
        props:{
            customList: Array, //所有
            selectList: Array,  //选中
            customBtnLoading: false,
            cbs:Object
        },
        data(){
            return {
                resetData: false, //vue2 深度对象 无法触发视图更新。 使用此方法。
                loading:false,
                keyword: '',
                category: '',
                disabledlist: [], //不删除列。
                dragData: [],  //非冻结列
                fixedData: [], //冻结列
                indicatorData: {},
                dialogHeight: '500px',
                formLoading:false,
            }
        },
        mounted() {
            this.showModal()
        },
        methods:{
            toquestiontitle(val) {
                return val.title
            },
            showModal(){
                let cloneDeep_customList = cloneDeep(this.customList)
                let cloneDeep_selectList = cloneDeep(this.selectList)
                this.initIndicatorData(cloneDeep_customList, cloneDeep_selectList)
            },
            //初始化数据
            initIndicatorData (allData, selectedData = []) {
                let realist = []
                this.disabledlist = []
                allData.forEach((el) => {
                    el["type"] = el.id + "_"
                    let checkedData = []
                    el.children.map((l) => {
                        let toObjectConfig = l['config'] ? JSON.parse(l['config']) : {}
                        let res_disabled = toObjectConfig ? toObjectConfig['disabled'] : null

                        if(l["checked"]) {
                            checkedData.push(l)
                        }
                        l["type"] = el["type"]
                        l['config'] = toObjectConfig
                        l['disabled'] = res_disabled
                        if(l['disabled']) {
                            this.disabledlist.push(l.id)
                        }
                        return l
                    })
                    el["checkedData"] = checkedData
                    el["checked"] = checkedData.length > 0 && checkedData.length == el.children.length ? true : false
                    el["isIndeterminate"] = el.checked ? false : checkedData.length > 0 && checkedData.length < el.children.length ? true : false
                    this.indicatorData[el.type] = el

                    realist.push(...checkedData)
                })
                this.category = allData.length > 0 ? Object.values(this.indicatorData)[0]["type"] : ""

                let uni_fixed_data = []
                let uni_drag_data = []

                let reduce_list = allData.reduce((prev,cur)=>{
                    if(cur?.children.length > 0){
                        prev.push(...cur.children);
                        return prev
                    }
                },[])

                for(const item of selectedData) {
                    reduce_list.forEach((el)=>{
                        if(el.checked) {
                            if (!!el['config']) {
                                let toObjectConfig = el['config']
                                if(item == el['id']) {
                                    if (toObjectConfig['fixed']) {
                                        uni_fixed_data.push({
                                            id: el['id'],
                                            width: 120,
                                            display_name: el["display_name"],
                                            fixed: toObjectConfig['fixed'],
                                            disabled: toObjectConfig['disabled']
                                        })
                                    } else {
                                        uni_drag_data.push({
                                            id: el['id'],
                                            width: 120,
                                            display_name: el["display_name"],
                                            fixed: null,
                                            disabled: toObjectConfig['disabled']
                                        })
                                    }
                                }
                            }else {
                                if(item == el['id']) {
                                    uni_drag_data.push({
                                        id: el['id'],
                                        width: 120,
                                        display_name: el["display_name"],
                                        fixed: null,
                                        disabled: null
                                    })
                                }
                            }
                        }
                    })
                }
                // reduce_list.forEach((el) => {
                //     if(el.checked) {
                //         if(!!el['config']){
                //             let toObjectConfig = el['config']
                //             for(const item of selectedData) {
                //                 if(item == el['id']) {
                //                     if (toObjectConfig['fixed']) {
                //                         uni_fixed_data.push({
                //                             id: el['id'],
                //                             width: 120,
                //                             display_name: el["display_name"],
                //                             fixed: toObjectConfig['fixed'],
                //                             disabled: toObjectConfig['disabled']
                //                         })
                //                     } else {
                //                         uni_drag_data.push({
                //                             id: el['id'],
                //                             width: 120,
                //                             display_name: el["display_name"],
                //                             fixed: null,
                //                             disabled: toObjectConfig['disabled']
                //                         })
                //                     }
                //                 }
                //             }
                //         }else{
                //             for(const item of selectedData) {
                //                 if(item == el['id']) {
                //                     uni_drag_data.push({
                //                         id: el['id'],
                //                         width: 120,
                //                         display_name:el["display_name"],
                //                         fixed: null,
                //                         disabled: null
                //                     })
                //                 }
                //             }
                //         }
                //     }
                // })
                this.fixedData = uniqBy(uni_fixed_data, 'id')
                this.dragData = uniqBy(uni_drag_data, 'id')
                // this.dragData = selectedData;
                this.loading = false
            },
            categoryShow(item) {

                if (this.keyword) {
                if (item.display_name.indexOf(this.keyword) > -1) {
                    return true
                } else {
                    let matching = item.children.filter((el) => {
                    return el.display_name.indexOf(this.keyword) > -1
                    })
                    return matching.length > 0 ? true : false
                }
                } else {
                    return true
                }
            },
            indicatorShow(item) {
                if (this.keyword) {
                return item.display_name.indexOf(this.keyword) > -1 ? true : false
                } else {
                return true
                }
            },
            topGroupChange(evt) {
                if (evt.added) {
                let { element, newIndex } = evt.added
                element.fixed = true
                }
            },
            bottomGroupChange(evt) {
                //左侧向右侧添加数据 时
                if (evt.added) {
                    let { element, newIndex } = evt.added
                    element.fixed = ""
                }
            },
            changeDrag(item, status, desc) {
                if(desc == 'bottom') {
                    this.changeCheckbox(this.dragData, item, status)
                }else{
                    this.changeCheckbox(this.fixedData, item, status)
                }
                let values = Object.keys(this.indicatorData)
                values.forEach(ele=>{
                    this.indicatorData[ele].children.forEach((el) => {
                        if (el.id == item.id) {
                            el.checked = status == 1 ? true : false
                            this.checkItem(el.checked, el, el.type)
                        }
                    })
                })
            },
            changeCategory(item, index) {
                this.category = item.type
                let jump = document.querySelectorAll(".indicator-block")
                this.$nextTick(() => {
                    jump[index].scrollIntoView()
                })
            },
            checkItem(val, el, type) {
                // console.log('indicatorData', this.indicatorData,val, el, type)
                this.resetData = !this.resetData
                el.checked = val
                this.changeCheckbox(
                    this.indicatorData[type]["checkedData"],
                    el,
                    val ? 1 : 2
                )
                if(val) {
                    this.changeCheckbox(this.dragData, el, val ? 1 : 2)
                }else{
                    this.changeCheckbox(this.dragData, el, val ? 1 : 2)
                    this.changeCheckbox(this.fixedData, el, val ? 1 : 2)
                }
                let checkedCount = this.indicatorData[type]["checkedData"].length
                this.indicatorData[type].checked =
                checkedCount === this.indicatorData[type].children.length
                this.indicatorData[type].isIndeterminate = this.isIndeterminateStatus(
                type,
                checkedCount
                )

                // this.$nextTick(()=>{
                //     this.$set(this.indicatorData, type, this.indicatorData[type])
                // })
            },
            handleCheckAllChange(val, index, ele) {
                this.resetData = !this.resetData
                // 全选／返选
                let arr = []
                ele.checked = val
                const re = this.indicatorData[index].children
                re.forEach((el) => {
                    if (!el.disabled) {
                        el.checked = val
                        let f_index = this.fixedData.findIndex((v) => v.id == el.id)
                        let d_index = this.dragData.findIndex((v) => v.id == el.id)
                        if (el.checked) {
                            arr.push(el)
                            // let curConfigFixed = ''
                            // if(!!el['config']){
                            //     let toObjectConfig = el['config']
                            //     if(toObjectConfig['fixed']) {
                            //         curConfigFixed = toObjectConfig['fixed']
                            //     }
                            // }
                            if (d_index == -1 && f_index == -1) {
                                let res_config = el['config'] ? el['config'] : {}
                                res_config['fixed'] = ''
                                this.dragData.push(
                                    {
                                        id: el['id'],
                                        width: 120,
                                        display_name:el["display_name"],
                                        config: res_config,
                                        fixed: res_config['fixed'],
                                    }
                                )
                            }
                        } else {
                            if (f_index > -1) {
                                this.fixedData.splice(f_index, 1)
                            }
                            if (d_index > -1) {
                                this.dragData.splice(d_index, 1)
                            }
                        }
                    } else {
                        arr.push(el)
                    }
                })

                this.indicatorData[index].checkedData = arr
                this.indicatorData[index].isIndeterminate = this.isIndeterminateStatus(index, arr.length)
                // this.$nextTick(()=>{
                //     this.$set(this.indicatorData, index, this.indicatorData[index])
                // })

            },
            isIndeterminateStatus(index, checkedCount) {
                return (
                checkedCount > 0 &&
                checkedCount < this.indicatorData[index].children.length
                )
            },
            changeCheckbox(arr = [], el, type) {
                let i = arr.findIndex((v) => v.id === el.id)
                switch (type) {
                case 1:
                    if (i == -1) {
                    arr.push({
                        id: el['id'],
                        width: 120,
                        display_name:el["display_name"],
                        config: el['config'],
                        fixed: el['fixed'],
                    })
                    }
                    break
                case 2:
                    if (i !== -1) {
                    arr.splice(i, 1)
                    }
                    break
                }
            },
            hideModal() {
                this.cbs.onClose()
            },
            submitModal() {
                let outList = uniqBy([...this.fixedData, ...this.dragData], 'id')
                this.cbs.onSubmit(uniq(outList))
            },
            // 清除全部
            handleClear() {
                let residue_fixed = this.fixedData.filter(item=>this.disabledlist.includes(item.id))
                let residue_drag = this.dragData.filter(item=>this.disabledlist.includes(item.id))
                this.fixedData = residue_fixed
                this.dragData = residue_drag

                let values = Object.keys(this.indicatorData)
                values.forEach(ele=>{
                    let checkedData = []
                    this.indicatorData[ele].children.forEach((item) => {
                        if ((item.disabled && item.disabled == true)) {
                            checkedData.push(item)
                            item["checked"] = true
                        } else {
                            item["checked"] = false
                        }
                    })
                    this.indicatorData[ele]["checkedData"] = checkedData
                    this.indicatorData[ele]["checked"] = checkedData.length > 0 && checkedData.length == this.indicatorData[ele].children.length ? true : false
                    this.indicatorData[ele]["isIndeterminate"] = this.indicatorData[ele].checked ? false : checkedData.length > 0 && checkedData.length < this.indicatorData[ele].children.length ? true : false
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.questions {
    width: 12px;
    height: 12px;
    line-height: 12px;
    text-align: center;
    border-radius: 10px;
    background-color: #333;
    color: #fff;
    font-size: 12px;
    display: inline-block;
    margin-left: 3px;
    cursor: pointer;
}
.wrapper{
    display: flex;
    width: 100%;
    min-width: 800px;
    border-top: 1px solid #eaebec;

}
.indicator-con{
    flex: 1;
}
.top-wrapper {
    display: flex;
    justify-content: flex-start;
    border: 1px solid #eaebec;
    border-top: none;
    border-bottom: none;
    align-items: center;
    height: 50px;
    padding-left: 8px;
}

.search {
    width: 250px;
}

.indicator-wrapper {
    display: flex;
    width: 100%;

    border: 1px solid #eaebec;
    border-radius: 4px;
}

.indicator-side {
    flex-shrink: 0;
    width: 160px;
    flex: 0 0 160px;
    overflow: auto;
    border-right: 1px solid #eaebec;
}

.indicator-category {
    padding-left: 16px;
    font-size: 14px;
    line-height: 40px;
    color: #333;
    cursor: pointer;
}

.item-stow {
    float: right;
    margin-right: 20px;
    cursor: pointer;
    color: #197afb;
    font-size: 13px;
    line-height: 32px;
}

.indicator-category--active {
    color: #197afb;
    background-color: #d6eaff;
}

.indicator-body {
    flex: auto;
    overflow-y: auto;
    height: calc(100vh - 320px);
    scroll-behavior: smooth;
}

.indicator-block {
    padding: 8px 12px;
    border-bottom: 1px solid #eaebec;

    .el-checkbox__label {
        font-size: 12px;
        font-weight: 400;
    }
}

.dragArea {
    // padding-left: 10px;
}

.indicator-group {
    position: relative;
    background-color: #f2f2f2;
    padding: 6px 0;
    ::v-deep.el-checkbox__label {
        font-size: 14px;
        font-weight: bold;
        color: #666;
    }
}

.indicator-drag {
    width: 225px;
    flex: 0 0 225px;
    padding: 0 0 5px 0;
    background-color: #fff;
    border: 1px solid #eaebec;
    border-top: none;
    z-index: 1;
    box-sizing: border-box;

    .drag-title {
        font-size: 14px;
        font-weight: 600;
        line-height: 100%;
        color: #333;
        padding: 0 10px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #eaebec;
        span{
            &:first-child{
                i{
                    color: #197afb;
                    font-style: normal;
                }
            }
            &:last-child{
                cursor: pointer;
                color: #ff0000;
            }
        }
    }

    .drag-sec {
        margin: 8px 0;
        font-size: 12px;
        line-height: 100%;
        color: #999;
        padding: 0 10px;
        font-weight: bold;
    }

    .indicator-drag-block.not-allow {
        cursor: not-allowed;
    }

    .indicator-content {
        // padding: 0 12px;
    }

    .mg5 {
        margin-bottom: 5px;
    }
    .fixed_line{
        position: relative;
        &::before {
            position: absolute;
            top: 22px;
            left: 12px;
            width: 45px;
            height: 1px;
            content: "";
            background-color: #999;
        }

        &::after {
            position: absolute;
            top: 22px;
            right: 12px;
            width: 45px;
            height: 1px;
            content: "";
            background-color: #999;
        }
    }

    .indicator-drag-block {
        position: relative;
        width: 195px;
        height: 30px;
        padding: 0 8px 0 8px;
        overflow: hidden;
        line-height: 30px;
        text-overflow: ellipsis;
        white-space: nowrap;
        background-color: #f2f2f2;
        border: 1px solid #e8eaec;
        border-radius: 3px;
        cursor: pointer;
        display: flex;
        align-items:center;
        justify-content: space-between;

        &.hide_ {
            display: none;
        }
        .indicator-drag-block-left{
            display: flex;
            align-items:center;
        }

        .indicator-name {
            display: inline-block;
            width: 150px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
    .indicator-drag-srcoll{
        overflow-y: auto;
        height: calc(100vh - 325px);
        scroll-behavior: smooth;
    }
    .drag-block.hover-class {
        &:hover {
            .edit-close {
                display: block;
            }
        }
    }

    .drag-block.selectedClass {
        background: #ecf5ff;
        cursor: all-scroll;
    }

    .drag-sepreate {
        position: relative;
        margin: 10px 0 10px;
        font-size: 12px;
        color: #999;
        text-align: center;
        font-weight: bold;

        &::before {
            position: absolute;
            top: 9px;
            left: 0;
            width: 32px;
            height: 1px;
            content: "";
            background-color: #e8eaec;
        }

        &::after {
            position: absolute;
            top: 9px;
            right: 0;
            width: 32px;
            height: 1px;
            content: "";
            background-color: #e8eaec;
        }
    }

    .indicator-limit-many {
        padding: 0 0 0 8px;
    }
}
































.stow-icon {
  color: #409eff;
  cursor: pointer;
}

.el-color-picker .el-color-picker__empty {
  display: none;
}

.el-popper.color-popper {
  width: 200px;

  .el-color-dropdown__main-wrapper {
    display: none;
  }

  .el-color-dropdown__btns {
    .el-color-dropdown__value {
      width: 70px;

      .el-input__inner {
        pointer-events: none;
        box-shadow: none;
      }
    }
  }
}
</style>
